var MIN_PADDING_VALUE = 10; // Add 0 in front of time when the value is less than 10, eg: 03

export var Pad = function Pad(time) {
  return time < MIN_PADDING_VALUE ? '0' + time.toString() : time.toString();
}; // To format display time in format : "HH hours and MM minutes"

export var formatTime = function formatTime(timeInSeconds) {
  var hours = Math.floor(timeInSeconds / 3600);
  var minutes = Math.floor(timeInSeconds % 3600 / 60);
  return {
    hours: hours,
    minutes: minutes
  };
};